const en = {
  // Navigation
  "nav.home": "Home",
  "nav.about": "About",
  "nav.tokenomics": "Tokenomics",
  "nav.roadmap": "Roadmap",
  "nav.staking": "Staking",
  "nav.vesting": "Vesting",
  "nav.devupdates": "Updates",
  "nav.fwb": "FWB",
  "nav.tokensale": "Token Sale",
  
  // Common sections
  "common.learnMore": "Learn more",
  "common.buyNow": "Buy now",
  "common.contactUs": "Contact us",
  "common.loading": "Loading",
  
  // Home page
  "home.hero.title": "The evolution of digital payments",
  "home.hero.subtitle": "eDOP Token: The utility token for the Dominican Republic financial ecosystem",
  "home.hero.cta": "Join the presale",
  
  // Home page bubbles
  "bubbles.home.revolution.title": "eDOP: Market Revolution",
  "bubbles.home.revolution.content": "The eDOP token aims to provide an efficient and accessible digital alternative in the cryptocurrency ecosystem, with an initial focus on emerging markets and a vision of global adoption.",
  
  "bubbles.home.ecosystem.title": "The eDOP Ecosystem",
  "bubbles.home.ecosystem.content": "Don't miss the opportunity to be part of the next generation of blockchain solutions in the crypto world.",
  
  // Buttons and additional texts
  "cta.whitepaper": "Whitepaper",
  "home.title": "eDOP: Digital Revolution",
  
  // About
  "about.title": "About eDOP Token",
  "about.description": "eDOP Token is a digital token designed to revolutionize payments in the Dominican Republic",
  
  // About page
  "about.page.title": "About Us",
  
  // About page bubbles
  "bubbles.about.edop.title": "About eDOP",
  "bubbles.about.edop.content": "eDOP is an efficient and accessible digital alternative in the crypto ecosystem, designed to address financial access issues, especially in emerging markets. It integrates ease of use with security, seeking global adoption.",
  
  "bubbles.about.mission.title": "Our Mission",
  "bubbles.about.mission.content": "To democratize access to digital financial services, offering accessible tools that allow people to take control of their finances without costly intermediaries.",
  
  "bubbles.about.transparency.title": "Transparency",
  "bubbles.about.transparency.content": "All operations are recorded immutably on the blockchain, guaranteeing absolute transparency. In addition, we are committed to publishing the results of security audits to build trust.",
  
  "bubbles.about.innovation.title": "Innovation",
  "bubbles.about.innovation.content": "We innovate by offering a user-centered crypto solution for financial inclusion, with an ecosystem that includes low-cost payments, incentives, and future developments such as a proprietary DEX and a mobile application.",
  
  "bubbles.about.community.title": "Community",
  "bubbles.about.community.content": "We foster a committed community through an incentive system that rewards participation, staking, and active use of the ecosystem, seeking a balanced distribution and expansion of our user base.",
  
  "bubbles.about.team.title": "Our Team",
  "bubbles.about.team.content": "We have a multidisciplinary team with extensive experience in digital finance, blockchain development, and emerging markets, supported by strategic advisors in key areas such as regulation and economics.",
  
  "bubbles.about.technology.title": "Our Technology",
  "bubbles.about.technology.content": "eDOP is a BEP-20 token that operates on the BNB Smart Chain (BSC), chosen for its optimal balance between speed, security, and affordable costs, using smart contracts developed under best practices.",
  
  "bubbles.about.speed.title": "Speed",
  "bubbles.about.speed.content": "Thanks to the BNB Smart Chain, transactions with eDOP Token are confirmed quickly, typically between 3 and 15 seconds, offering superior efficiency to traditional systems and other blockchains.",
  
  "bubbles.about.lowcost.title": "Low Cost",
  "bubbles.about.lowcost.content": "eDOP offers drastically reduced fees, ranging between 0% and 1% per transaction, compared to 5% to 10% for traditional remittance services. This is achieved through the use of the efficient BNB Smart Chain, optimized smart contracts, and the elimination of intermediaries, allowing affordable transactions, even for micropayments.",
  
  "bubbles.about.security.title": "Security and Contact",
  "bubbles.about.security.content": "Security is a priority, implementing contracts audited by recognized firms, proven tools (OpenZeppelin), multi-signature systems, and constant monitoring. For inquiries, contact us at info@edoptoken.com, admin@edoptoken.com, or through our official social networks published on our website.",
  
  // Tokenomics
  "tokenomics.title": "Token Distribution",
  "tokenomics.supply": "Total supply",
  
  // Tokenomics Page
  "tokenomics.page.title": "Tokenomics",
  "tokenomics.page.subtitle": "eDOP Token Distribution and Economics",
  
  "tokenomics.intro.title": "Tokenomics",
  "tokenomics.intro.content": "Content: The eDOP token has a fixed total supply of 1 billion units (1,000,000,000 eDOP). Its economic design includes a strategic distribution to incentivize early participation, reward long-term users through staking, ensure market liquidity, and fund ongoing development and adoption of the ecosystem.",
  
  "tokenomics.distribution.title": "Token Distribution",
  "tokenomics.distribution.content": "The total supply of 1 billion eDOP is allocated as follows:",
  "tokenomics.distribution.items": [
    "40% Public Presale: For early adopters.",
    "30% Staking Rewards: Distributed over 2 years to reward holders.",
    "10% Liquidity: Locked for a minimum of 10 years or in perpetuity for stability.",
    "10% Marketing and adoption: For growth and outreach.",
    "5% Development: With gradual release for the team (vesting).",
    "5% Chain Inventory: For technical operations of the ecosystem."
  ],
  
  "tokenomics.purpose.title": "eDOP: A Token with Purpose",
  "tokenomics.purpose.content": "With a total supply limited to 1 billion units, the eDOP token is designed to be useful and sustainable. Its strategic distribution ensures funds for staking rewards (30%), long-term liquidity (10%) and growth. Primarily, you can use eDOP as an efficient and low-cost payment method, or stake it to earn rewards and additional benefits within our digital financial ecosystem.",
  
  "tokenomics.utility.title": "Token Utility",
  "tokenomics.utility.items": [
    "Governance: eDOP holders can vote on key proposals that affect the development and direction of the project.",
    "Staking: Earn significant rewards by staking your tokens, with competitive annual rates.",
    "Reduced Fees: Users who hold eDOP enjoy reduced fees on all transactions within the platform.",
    "Access to Exclusive Features: Unlock advanced features and tools within our platform.",
    "Payment Method: Use eDOP for fast and economical transactions within our ecosystem."
  ],
  
  // Token sale
  "tokensale.title": "Token Sale",
  "tokensale.subtitle": "Participate in our presale",
  "tokensale.price": "Current price",
  "tokensale.connect": "Connect wallet",
  
  // Footer
  "footer.rights": "All rights reserved",
  "footer.terms": "Terms and conditions",
  "footer.privacy": "Privacy policy",
  "footer.fwb": "Friends with Benefits",
  
  // Wallet
  "wallet.connect": "Connect Wallet",
  
  // News
  "news.label": "NEWS",
  
  // Privacy Policy Page
  "privacy.page.title": "Privacy Policy",
  
  // Privacy Policy Bubbles
  "bubbles.privacy.commitment.title": "Commitment to Your Privacy",
  "bubbles.privacy.commitment.content": "At eDOP Token, we are committed to full transparency and protection of your data. As a project focused on democratizing access to digital financial services, we understand the importance of trust.",
  
  "bubbles.privacy.nocollection.title": "We Don't Collect Information",
  "bubbles.privacy.nocollection.content": "To fulfill our mission of financial inclusion, we never request or ask for identification data. Avoid being a victim of phishing and never reveal your private keys or seed phrases - eDOP Token will never ask for them, remember that.",
  
  "bubbles.privacy.usage.title": "How We Use Your Information",
  "bubbles.privacy.usage.content": "We don't collect personal data or any information. We only use your wallet address to operate, technical data to maintain platform security, and optionally, some details that improve your experience. All under good practices and without sharing information with third parties.",
  
  "bubbles.privacy.security.title": "Security and Protection",
  "bubbles.privacy.security.content": "We apply the same security measures that protect our smart contracts: OpenZeppelin protocols, multi-signature in key operations, limits to reduce risks, and constant monitoring. Everything is aligned with our audits, ensuring the security of your data and digital assets.",
  
  // FWB (Friends with Benefits) Page
  "fwb.page.title": "Friends with Benefits (FWB)",
  
  // FWB Page Bubbles
  "bubbles.fwb.community.title": "eDOP Community (FWB)",
  "bubbles.fwb.community.content": "At eDOP, we believe in a global community that seeks to democratize financial access. Our ecosystem is designed for users to take control and collaborate towards a more equitable digital economy, especially in emerging markets.",
  
  "bubbles.fwb.join.title": "How to Join and Participate",
  "bubbles.fwb.join.content": "Become an active part of eDOP by using the token for payments, participating in our staking program to support the network, and preparing to contribute to the future governance of the ecosystem. Your participation is key to our growth.",
  "bubbles.fwb.join.date": "Date: April 04, 2025",
  
  "bubbles.fwb.benefits.title": "Benefits of the eDOP Community",
  "bubbles.fwb.benefits.content": "By participating in eDOP, you can earn periodic rewards through staking (from 30% of the total supply allocated). Additionally, active holding can give you access to benefits such as fee discounts or priority in new ecosystem features.",
  
  "bubbles.fwb.connect.title": "Connect with the Community",
  "bubbles.fwb.connect.content": "Stay informed and connected with the eDOP project. Find links to our official community channels, technical documentation, and contact methods directly on our official website.",
  
  // Terms and Conditions Page
  "terms.page.title": "Terms and Conditions",
  
  // Terms Page Bubbles
  "bubbles.terms.risk.title": "Risk Warnings:",
  "bubbles.terms.risk.content": "Investing in eDOP Token involves significant risks, including high volatility and the possible total or partial loss of capital. The token's value depends on the market, there is no guarantee of profitability, and digital assets do not have deposit insurance. Carefully consider your risk tolerance before investing.",
  
  "bubbles.terms.liability.title": "Limitation of Liability",
  "bubbles.terms.liability.content": "The performance of eDOP Token is subject to market risks beyond the control of the issuer (Servicios de Desarrollo de Algoritmos y Consultoría de Tecnología Blockchain, SRL). We are not responsible for losses resulting from volatility, liquidity fluctuations, or risks inherent in investing in digital assets.",
  
  "bubbles.terms.issuer.title": "Issuer and Legal Compliance",
  "bubbles.terms.issuer.content": "eDOP Token is issued by Servicios de Desarrollo de Algoritmos y Consultoría de Tecnología Blockchain, SRL, a legally established entity. We seek to operate in compliance with applicable regulations and have legal advice on digital assets and financial law.",
  
  "bubbles.terms.contact.title": "Contact",
  "bubbles.terms.contact.content": "For inquiries related to these terms, the eDOP Token project, or for more information, you can reach out to our Email: or consult additional resources on our Website.",
  
  // Development Updates Page
  "devupdates.page.title": "Development Updates",
  
  // Development Updates Page Bubbles
  "bubbles.devupdates.intro.title": "Development Updates",
  "bubbles.devupdates.intro.content": "According to the technical plan outlined in the whitepaper, eDOP's development focuses on creating key components such as a low-cost payment platform, a future proprietary decentralized exchange (DEX), and a mobile application. The entire ecosystem is designed to operate on the BNB Smart Chain, seeking a balance between efficiency, security, and accessibility.",
  
  "bubbles.devupdates.latest.title": "Latest Updates",
  "bubbles.devupdates.latest.content": "Based on the original whitepaper plan and preparing for our Phase 1 (estimated for late Q2 2025), our current focus includes token launch preparations, payment platform activation, and securing initial exchange listings. For actual progress and confirmed announcements, please always check our official channels.",
  "bubbles.devupdates.latest.date": "Date: April 28, 2025",
  
  "bubbles.devupdates.events.title": "Upcoming Community Events",
  "bubbles.devupdates.events.content": "Our community will establish a plan for active community interaction, mentioning strategies such as regular educational webinars and presence at key industry events. Although dates for upcoming AMA sessions or other specific events are not specified in the document, our commitment is to maintain fluid and educational communication.",
  "bubbles.devupdates.events.date": "Date: April 28, 2025",
  
  "bubbles.devupdates.technical.title": "Technical Update: Smart Contract Audit",
  "bubbles.devupdates.technical.content": "According to our security approach outlined in the whitepaper, there is a commitment to have eDOP Token's smart contracts audited by recognized external firms (examples such as CertiK or Hacken are mentioned) prior to launch. These audit reports are planned to be published on our website for full transparency with the community.",
  "bubbles.devupdates.technical.date": "Date: April 28, 2025",
  
  "bubbles.devupdates.partnership.title": "Strategic Partnership Announcement",
  "bubbles.devupdates.partnership.content": "Our whitepaper establishes the strategy and importance of forming strategic alliances for the growth and utility of eDOP Token, mentioning plans to collaborate with merchants, especially in emerging markets. However, the founding document does not contain specific announcements of already signed partnerships; it describes the intention and approach to seek them as part of the roadmap.",
  "bubbles.devupdates.partnership.date": "Date: April 28, 2025",
  
  "bubbles.devupdates.previous.title": "Previous Updates",
  "bubbles.devupdates.previous.content1": "The whitepaper serves as the initial master plan and presentation of the eDOP Token project. By its nature, previous updates or milestones already completed since its publication will appear in the official channels for information.",
  "bubbles.devupdates.previous.content2": "To access an archive of previous news, advances, and announcements, please head to the news/blog sections or historical channels on eDOP's official social networks. Come back here to see all our previous updates!",

  // Roadmap Page
  "roadmap.page.title": "Roadmap",
  "roadmap.page.subtitle": "Our vision and milestones for the future",

  // Roadmap Phases
  "roadmap.phase1.title": "Phase 1: Foundation and Launch",
  "roadmap.phase1.description": "Development of token fundamentals and presale launch",
  "roadmap.phase1.items": [
    "Smart Contract Development and Audit",
    "Token Presale",
    "Community Building",
    "Website Launch"
  ],

  "roadmap.phase2.title": "Phase 2: Market Launch and Expansion",
  "roadmap.phase2.description": "DEX listings and marketing campaign kickoff",
  "roadmap.phase2.items": [
    "DEX Listings",
    "Marketing Campaigns",
    "Strategic Partnerships",
    "Community Growth"
  ],

  "roadmap.phase3.title": "Phase 3: Product Development",
  "roadmap.phase3.description": "Payment platform development and wallet integration",
  "roadmap.phase3.items": [
    "Payment Platform Beta",
    "Wallet Integration",
    "Merchant Onboarding",
    "Security Audits"
  ],

  "roadmap.phase4.title": "Phase 4: Ecosystem Expansion",
  "roadmap.phase4.description": "Expansion of the ecosystem and new features",
  "roadmap.phase4.items": [
    "Mobile App Launch",
    "Cross-Chain Integration",
    "Governance Implementation",
    "New Partnerships"
  ],

  // Roadmap Status
  "roadmap.status.completed": "Completed",
  "roadmap.status.inProgress": "In Progress",
  "roadmap.status.upcoming": "Upcoming",

  // Roadmap Additional Sections
  "roadmap.vision.title": "Our Vision",
  "roadmap.vision.content": "Shaping the future of digital payments in the Dominican Republic and beyond",

  "roadmap.updates.title": "Recent Updates",
  "roadmap.updates.content": "Stay informed about our progress",

  // Vesting Page
  "vesting.page.title": "eDOP Vesting Platform",
  
  // Vesting Page - Bubbles
  "bubbles.vesting.platform.title": "eDOP Vesting Platform",
  "bubbles.vesting.platform.content": "Tokens allocated to the development team (5% of the total) are not delivered all at once. First, they are completely locked for 120 days. Then, the team receives a small portion each month (a linear 2% of their allocation). This process is called vesting and ensures that the team remains committed to the eDOP Token project in the long term.",
  
  "bubbles.vesting.emission.title": "Gradual Token Emission",
  "bubbles.vesting.emission.content": "eDOP controls the slow release of tokens with vesting for the team and the gradual distribution of staking rewards (30% over 2 years). This controlled emission seeks to avoid sharp price drops and align token circulation with project growth.",

  // VestingBox4 Component
  "vestingBox4.claimedTokens": "Claimed Tokens",
  "vestingBox4.loading": "Loading...",
  "vestingBox4.availableToClaim": "Available to Claim",
  "vestingBox4.processing": "Processing...",
  "vestingBox4.claimTokens": "Claim Tokens",
  "vestingBox4.successTransaction": "Transaction Successful!",
  "vestingBox4.claimSuccess": "You have successfully claimed {{amount}} $eDOP.",
  "vestingBox4.viewTransaction": "View Transaction",
  "vestingBox4.close": "Close",
  "vestingBox4.noTokensAvailable": "You have no tokens available to claim",
  "vestingBox4.claimError": "Error claiming tokens:",
  "vestingBox4.unknownError": "Unknown error",

  // VestingBox3 Component
  "vestingBox3.calendar": "Vesting Calendar",
  "vestingBox3.start": "Start",
  "vestingBox3.end": "End",
  "vestingBox3.cliffPeriod": "Cliff Period",
  "vestingBox3.loading": "Loading...",
  "vestingBox3.days": "days",
  "vestingBox3.progress": "Progress",
  "vestingBox3.viewDetailedCalendar": "View Detailed Calendar",
  "vestingBox3.vestingStart": "Vesting Start",
  "vestingBox3.cliffEnd": "Cliff Period End",
  "vestingBox3.vestingEnd": "Vesting End",
  "vestingBox3.weeklyReleases": "Weekly Releases",
  "vestingBox3.releaseDescription": "After the 90-day cliff period, your tokens are released weekly at 1% over approximately 2 years.",
  "vestingBox3.close": "Close",

  // VestingBox2 Component
  "vestingBox2.nextRelease": "Next Release",
  "vestingBox2.noVesting": "No vesting",
  "vestingBox2.loading": "Loading...",
  "vestingBox2.notScheduled": "Not scheduled",
  "vestingBox2.availableNow": "Available now",
  "vestingBox2.days": "day(s)",
  "vestingBox2.hours": "hr(s)",
  "vestingBox2.minutes": "min",
  "vestingBox2.amountToRelease": "Amount to Release",
  "vestingBox2.claimAvailableTokens": "Claim Available Tokens",
  "stakingBox2.infoModal.understood": "Understood",
  
  // StakingBox1 Component
  "stakingBox1.stakedBalance": "STAKED BALANCE",
  "stakingBox1.stakeable": "YOUR STAKEABLE",
  "stakingBox1.stakeNow": "STAKE NOW",
  "stakingBox1.success": "Success!",
  "stakingBox1.info": "INFO",
  "stakingBox1.accept": "Accept",
  "stakingBox1.connectWallet": "Please connect your wallet first",
  "stakingBox1.enterValidAmount": "Please enter a valid amount",
  "stakingBox1.errorStaking": "There was a problem staking your tokens",
  "stakingBox1.userRejected": "Transaction has been rejected by the user",
  "stakingBox1.insufficientFunds": "Insufficient funds to perform the transaction",
  "stakingBox1.contractRejection": "The transaction was rejected by the contract",
  "stakingBox1.stakeTokens": "Stake Tokens",
  "stakingBox1.processingTransaction": "Processing Transaction",
  "stakingBox1.waitForStaking": "Please wait while your staking is completed...",
  "stakingBox1.transactionSuccess": "Transaction Successful!",
  "stakingBox1.successStaked": "You have successfully staked {{amount}} $eDOP",
  "stakingBox1.exit": "Exit",
  "stakingBox1.available": "Available: {{amount}}",
  "stakingBox1.confirm": "Accept",
  "stakingBox1.cancel": "Cancel",

  // Staking Page
  "staking.page.title": "eDOP Staking Platform",
  
  // Staking Bubbles
  "bubbles.staking.platform.title": "eDOP Staking Platform",
  "bubbles.staking.platform.content": "It is the function within eDOP where you can lock your tokens to support the project. In exchange for keeping them locked there, the platform gives you rewards (more eDOP Token).",
  
  "bubbles.staking.benefits.title": "Staking Benefits",
  "bubbles.staking.benefits.items": [
    "Earn more eDOP: You receive extra tokens as a reward for locking yours.",
    "Participate in decisions: It gives you the opportunity to vote or influence the future of the project.",
    "Support the token: You help make the token's value more stable in the long term."
  ],
  
  "bubbles.staking.rewards.title": "Rewards",
  "bubbles.staking.rewards.content": "You will be able to claim your accumulated rewards once the claim function is active on the platform.",
  
  // StakingBox4 Component
  "stakingBox4.totalRewards": "TOTAL REWARDS",
  "stakingBox4.claimRewards": "Claim Rewards",
  "stakingBox4.processing": "Processing...",
  "stakingBox4.claimed": "Claimed",
  "stakingBox4.success": "Success!",
  "stakingBox4.info": "INFO",
  "stakingBox4.accept": "Accept",
  "stakingBox4.noRewards": "No rewards available to claim",
  "stakingBox4.claimedSuccess": "Rewards claimed successfully! You have received {{amount}} $eDOP",
  "stakingBox4.errorClaiming": "Could not claim rewards",
  "stakingBox4.userRejected": "Transaction has been rejected by the user",
  "stakingBox4.insufficientFunds": "Insufficient funds to perform the transaction",
  "stakingBox4.contractRejection": "The transaction was rejected by the contract",
  
  // StakingBox3 Component
  "stakingBox3.estimatedRewards": "ESTIMATED REWARDS",
  "stakingBox3.rewardsDynamic": "• The rewards percentage is dynamic",
  "stakingBox3.monthly": "• Monthly = {{rate}}%",
  "stakingBox3.daily": "• Daily = {{rate}}%",

  // StakingBox2 Component
  "stakingBox2.poolPercentage": "POOL PERCENTAGE",
  "stakingBox2.stakedBalance": "STAKED BALANCE",
  "stakingBox2.processing": "Processing...",
  "stakingBox2.withdrawTokens": "Withdraw Tokens",
  "stakingBox2.success": "Success!",
  "stakingBox2.info": "INFO",
  "stakingBox2.accept": "Accept",
  "stakingBox2.tokensWithdrawn": "Tokens successfully withdrawn",
  "stakingBox2.errorWithdrawing": "Could not withdraw tokens",
  "stakingBox2.userRejected": "Transaction has been rejected by the user",
  "stakingBox2.insufficientFunds": "Insufficient funds to perform the transaction",
  "stakingBox2.contractRejection": "The transaction was rejected by the contract",
  "stakingBox2.infoModal.title": "Pool Percentage",
  "stakingBox2.infoModal.content": "This percentage represents the proportion of your staked tokens relative to the total tokens in staking. The higher your percentage, the higher the proportion of rewards you will receive.",
  "stakingBox2.infoModal.understood": "Understood",
  
  // StakingSupply Component
  "stakingSupply.title": "Total Staking Supply",
  "stakingSupply.totalSupply": "Total Supply (Millions)",
  
  // Abbreviated months for charts
  "months.jan": "Jan",
  "months.feb": "Feb",
  "months.mar": "Mar",
  "months.apr": "Apr",
  "months.may": "May",
  "months.jun": "Jun",
  "months.jul": "Jul",
  "months.aug": "Aug",
  "months.sep": "Sep",
  "months.oct": "Oct",
  "months.nov": "Nov",
  "months.dec": "Dec",
  
  // PresaleBox Component
  "presaleBox.buyMessage": "BUY YOUR $eDOP TOKENS NOW",
  "presaleBox.days": "Days",
  "presaleBox.hours": "Hours",
  "presaleBox.minutes": "Min",
  "presaleBox.seconds": "Sec",
  "presaleBox.presalePending": "Presale starting soon",
  "presaleBox.presaleCompleted": "Presale completed",
  "presaleBox.stage": "Stage {{current}} of {{total}}",
  "presaleBox.fundsRaised": "USDT Raised: ${{raised}} / ${{goal}}",
  "presaleBox.tokensPurchased": "Your eDOP Tokens Purchased: {{amount}}",
  "presaleBox.tokensStaked": "Your $eDOP tokens staked = {{amount}}",
  "presaleBox.tokenPrice": "1 eDOP = ${{price}} USDT",
  "presaleBox.payWith": "Pay with {{currency}}",
  "presaleBox.receive": "Receive $eDOP",
  "presaleBox.maximum": "Maximum",
  "presaleBox.insufficientFunds": "You don't have enough {{currency}} to pay for this transaction.",
  "presaleBox.buyWithBnb": "Buy with {{symbol}}",
  "presaleBox.buyWithUsdt": "Buy with {{symbol}}",
  "presaleBox.buyWithCard": "Buy with Card",
  "presaleBox.goToDex": "Go to DEX",
  "presaleBox.balance": "Balance in {{currency}}:",
  "presaleBox.connectWallet": "Connect your wallet",
  "presaleBox.reloadBnb": "Not enough BNB? Reload here",
  "presaleBox.developedBy": "Developed by",
  
  // Information modal for PresaleBox
  "presaleBox.infoModal.title": "Attention!",
  "presaleBox.infoModal.tokensPurchased": "The total tokens you have purchased are all tokens acquired with the connected wallet. This includes all staked and unstaked tokens.",
  "presaleBox.infoModal.ok": "OK",
  "presaleBox.infoModal.stakeableTokens": "Unclaimed $eDOP purchased with ETH or ERC-20 USDT can be used in staking now. Please note that all tokens used in early staking can be withdrawn 7 days after token claiming is activated, which will happen after the presale has concluded.",
  
  // Alerts for PresaleBox
  "presaleBox.alert.connectWallet": "Please connect your wallet first",
  "presaleBox.alert.enterValidAmount": "Please enter a valid amount",
  "presaleBox.alert.presaleNotStarted": "The presale starts on June 01, 2025. Please wait for the presale to start.",
  "presaleBox.alert.confirmInWallet": "Please confirm the transaction in your wallet...",
  "presaleBox.alert.purchaseSuccess": "Purchase successful! You've bought {{amount}} eDOP tokens",
  "presaleBox.alert.paymentMethodNotSupported": "Payment method not supported",
  
  // Simplified errors for PresaleBox
  "presaleBox.error.insufficientTokens": "There are not enough tokens available at the moment. Please try again later.",
  "presaleBox.error.userDenied": "Transaction rejected. You must confirm the transaction in your wallet to continue.",
  "presaleBox.error.gas": "Transaction gas error. Make sure you have enough BNB to cover gas fees.",
  "presaleBox.error.nonce": "Transaction sequence error. Try refreshing the page and trying again.",
  "presaleBox.error.contractFailure": "Transaction failed. The contract might be paused or out of tokens.",
  "presaleBox.error.generic": "Transaction error. Please try again later.",
  
  // Required network for PresaleBox
  "presaleBox.network.bnbMainnet": "BNB Smart Chain",
  "presaleBox.network.bnbTestnet": "BSC Testnet",
  "presaleBox.network.bnbBoth": "BNB Smart Chain or BSC Testnet",
  "presaleBox.network.usdtBep20": "BNB Smart Chain (for USDT BEP-20)",
  "presaleBox.network.usdtErc20": "Ethereum (for USDT ERC-20)",
  "presaleBox.network.usdtTestnet": "BSC Testnet (for USDT Testnet)",
  "presaleBox.network.usdtOptions": "Ethereum (for USDT ERC-20) or BNB Smart Chain (for USDT BEP-20)",
  "presaleBox.network.usdtOptionsTestnet": "Ethereum (for USDT ERC-20) or BNB Smart Chain/Testnet (for USDT BEP-20)",
  "presaleBox.network.compatible": "compatible network",
  "presaleBox.network.changeNetwork": "To pay with {{method}}, you need to switch to the {{network}} network",
  
  // Contract error messages
  "contracts.error.invalidConfig": "Contract {{contractName}} not properly configured",
  "contracts.error.initialization": "Error initializing contract {{contractName}}: {{error}}",
  "contracts.error.notInitialized": "Contract is not initialized",
  "contracts.error.walletNotConnected": "Wallet not connected. Please connect your wallet to continue",
  "contracts.error.transaction": "Transaction error: {{error}}",
  "errors.contractInitialization": "Error initializing contracts",
  
  // Wallet errors
  "wallet.error.noMetamask": "MetaMask is not installed",
  "wallet.error.noAccount": "Could not get account",
  "wallet.error.networkNotSupported": "Network not supported",
  "wallet.error.connection": "Error connecting wallet",
  "wallet.error.networkSwitch": "Error switching network",
  
  // Presale error messages
  "presale.error.connectWalletFirst": "Please connect your wallet first",
  "presale.error.contractNotReady": "Presale contract is not ready",
  "presale.error.noSigner": "Could not get signer. Please reconnect your wallet.",
  "presale.error.priceChanged": "Price error: The price has changed. Please refresh the page.",
  "presale.error.userRejected": "Transaction rejected by user",
  "presale.error.insufficientFunds": "Insufficient funds to complete the transaction",
  "presale.error.purchaseError": "Purchase error: {{error}}",
  "presale.error.unknown": "Unknown",
  "presale.error.usdtApprovalError": "USDT approval error",
  "presale.error.cannotClaimTokens": "Cannot claim tokens at this time",
  
  // Console messages - for developers only, not shown to users
  "console.contracts.initialized": "Presale contracts initialized successfully",
  "console.contracts.initError": "Error initializing contracts:",
  "console.tokens.availableError": "Error loading available tokens:",
  "console.exchangeRates.error": "Error fetching exchange rates:",
  "console.price.error": "Error getting contract price:",
  "console.price.fromContract": "Price obtained from contract:",
  "console.price.contractError": "Error getting price from contract:",
  "console.price.usingFallback": "Using fallback price:",
  "console.bnb.buying": "Buying with BNB: {{amount}} BNB to get {{tokensToReceive}} tokens",
  "console.price.perToken": "Price per token: {{price}} USDT",
  "console.signer.available": "Signer available: {{available}}",
  "console.account.current": "Current account: {{account}}",
  "console.bnb.success": "BNB purchase successful:",
  "console.bnb.error": "Error buying with BNB:",
  "console.usdt.approving": "Approving USDT spending...",
  "console.price.fromContractUsdt": "Price obtained from contract (USDT):",
  "console.price.contractErrorUsdt": "Error getting price from contract (USDT):",
  "console.price.usingFallbackUsdt": "Using fallback price (USDT):",
  "console.usdt.buying": "Buying with USDT: {{amount}} USDT with price {{price}} per token",
  "console.tokens.expected": "Expected tokens: {{tokens}}",
  "console.usdt.success": "USDT purchase successful:",
  "console.usdt.error": "Error buying with USDT:",
  "console.tokens.claimSuccess": "Tokens claimed successfully:",
  "console.tokens.claimError": "Error claiming tokens:",
  "console.purchases.error": "Error fetching purchase data:",

  // Ticker Messages
  "ticker.message1": "1️⃣ Join the eDOP presale! 🚀 Take advantage of exclusive prices before launch. 🔥",
  "ticker.message2": "2️⃣ eDOP revolutionizes the market! 💎 Join the ecosystem and secure your place in the new digital era. ⚡",
  "ticker.message3": "3️⃣ Last days of the eDOP presale! ⏳ Don't stay out, get your tokens before it's too late. 🎯",

  // Meta Tags
  "meta.description": "eDOP Token - The currency of the Dominican financial ecosystem"
};

export default en;